import React,{useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {
	useSelector
} from 'react-redux'
import {
	selectProgressById,
	selectProgressIds,
	getProgressData
} from './progressSlice'
import { Line } from 'react-chartjs-2'
import Spinner from 'react-bootstrap/Spinner'
import classes from './Progress.module.css'


const Metric = props =>{
	const {id} = props
	const metricData = useSelector(state=>selectProgressById(state,id))
	const {assessmentName,progressData} = metricData
	const labels = progressData.map(d=>d.date)
	const data = progressData.map(d=>d.value)
	const r = ~~(100 * Math.random() - 25)
	const borderColor = `hsla(${213-r}, 100%, 60%,0.8)`
	const backgroundColor = `hsla(${213-r}, 100%, 60%,0.4)`
	if(!data.length) return null
	return (
		<div style={{height:'256px',width:'100%',position:'relative'}}>
			<Line
				options={{
					maintainAspectRatio:false,
					responsive:true,
				}}
				data={
					{
						labels,
						datasets: [{
							lineTension: 0,
							label: assessmentName,
							backgroundColor,
							borderColor,
							data
						}]
					}
				}/>
		</div>
	)
}

const Progress = React.memo(props => {
	const progressIds = useSelector(selectProgressIds)
	const status = useSelector(state=>state.progress.status)
	const dispatch = useDispatch()
	useEffect(()=>{
		dispatch(getProgressData())
	},[])
	return (
		<React.Fragment>
			<div className="text-center my-3">
				<h2 className="shadow" style={{
					padding:'16px 32px',
					background:'#000C2D',
					color:'#eee',
					borderRadius:'100px',
					display:'inline-block'
				}}>
					<i style={{color:'#4dd1ff'}} className="far fa-chart-bar"></i> Progress
				</h2>
			</div>
			<div className={[
				"shadow mx-3 bg-white p-3 rounded",
				classes.Metrics
			].join(' ')}>
				{
					status !== 'loading' ? 
					progressIds.map( id => <Metric key={id} id={id}/> ) :
					<div className="d-flex justify-content-center">
						<Spinner animation="border" role="status">
							<span className="sr-only">Loading...</span>
						</Spinner>
					</div>
				}
			</div>
		</React.Fragment>
	)
})

export default Progress